import React, { useEffect, useState } from 'react';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import { CardSkeleton, SkeletonText } from '../../components/common/Skeleton';

const parseLinks = (value) => String(value || '').split('\n').map((line) => line.trim()).filter(Boolean).map((line) => {
  const [label, path] = line.split('|');
  return { label: (label || '').trim(), path: (path || '').trim() };
}).filter((item) => item.label && item.path);
const stringifyLinks = (list=[]) => list.map((item) => `${item.label || ''}|${item.path || ''}`).join('\n');
const fieldStyle = { width:'100%', padding:12, borderRadius:10, border:'1px solid #d0d5dd' };

export default function Settings() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [inquiries, setInquiries] = useState([]);
  const [form, setForm] = useState({
    siteName:'', siteTagline:'', logoText:'', footerDescription:'',
    contactEmail:'', contactPhone:'', whatsappNumber:'', officeAddress:'', officeHours:'', googleMapLink:'',
    facebookLink:'', instagramLink:'', linkedinLink:'', youtubeLink:'',
    contactHeroTitle:'', contactHeroDescription:'', contactFormTitle:'', contactFormDescription:'',
    footerQuickLinks:'', footerServiceLinks:''
  });

  const loadData = async () => {
    setLoading(true);
    const [settingsResult, inquiryResult] = await Promise.all([
      httpAction({ url: apis().publicSettings, silent: true }),
      httpAction({ url: apis().contactList, silent: true }),
    ]);
    if (settingsResult?.status) {
      const s = settingsResult.settings || {};
      setForm({
        siteName: s.siteName || '', siteTagline: s.siteTagline || '', logoText: s.logoText || '', footerDescription: s.footerDescription || '',
        contactEmail: s.contactEmail || '', contactPhone: s.contactPhone || '', whatsappNumber: s.whatsappNumber || '', officeAddress: s.officeAddress || '', officeHours: s.officeHours || '', googleMapLink: s.googleMapLink || '',
        facebookLink: s.facebookLink || '', instagramLink: s.instagramLink || '', linkedinLink: s.linkedinLink || '', youtubeLink: s.youtubeLink || '',
        contactHeroTitle: s.contactHeroTitle || '', contactHeroDescription: s.contactHeroDescription || '', contactFormTitle: s.contactFormTitle || '', contactFormDescription: s.contactFormDescription || '',
        footerQuickLinks: stringifyLinks(s.footerQuickLinks), footerServiceLinks: stringifyLinks(s.footerServiceLinks),
      });
    }
    if (inquiryResult?.status) setInquiries(inquiryResult.list || []);
    setLoading(false);
  };

  useEffect(() => { loadData(); }, []);

  const submitHandler = async (e) => {
    e.preventDefault();
    setSaving(true);
    const payload = { ...form, footerQuickLinks: parseLinks(form.footerQuickLinks), footerServiceLinks: parseLinks(form.footerServiceLinks) };
    const result = await httpAction({ url: apis().updateSettings, method: 'PUT', body: payload });
    setSaving(false);
    if (result?.status) loadData();
  };

  if (loading) return <div><SkeletonText width="230px" height={28} /><div style={{ marginTop:18 }}><CardSkeleton count={3} height={180} /></div></div>;

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>General Settings</h2>
        <p style={{ color: '#667085' }}>Manage footer, contact page, quick links, and direct business details. About page and partners now have separate CMS sections.</p>
      </div>
      <form onSubmit={submitHandler} style={{ display:'grid', gap:16 }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:16 }}>
          {Object.entries(form).filter(([key]) => !['footerQuickLinks','footerServiceLinks'].includes(key)).map(([key, value]) => (
            <label key={key} style={{ display:'block', background:'#fff', padding:16, borderRadius:16 }}>
              <div style={{ marginBottom:6, fontWeight:600 }}>{key}</div>
              {String(value || '').length > 120 || key.toLowerCase().includes('description') || key.toLowerCase().includes('address') ? (
                <textarea rows="4" value={value} onChange={(e)=>setForm({ ...form, [key]:e.target.value })} style={fieldStyle} />
              ) : (
                <input value={value} onChange={(e)=>setForm({ ...form, [key]:e.target.value })} style={fieldStyle} />
              )}
            </label>
          ))}
        </div>
        <label style={{ background:'#fff', padding:16, borderRadius:16 }}><div style={{ marginBottom:6, fontWeight:600 }}>Footer Quick Links</div><textarea rows="6" value={form.footerQuickLinks} onChange={(e)=>setForm({...form, footerQuickLinks:e.target.value})} style={fieldStyle} /><small>One per line: label|path</small></label>
        <label style={{ background:'#fff', padding:16, borderRadius:16 }}><div style={{ marginBottom:6, fontWeight:600 }}>Footer Service Links</div><textarea rows="6" value={form.footerServiceLinks} onChange={(e)=>setForm({...form, footerServiceLinks:e.target.value})} style={fieldStyle} /><small>One per line: label|path</small></label>
        <div><button type="submit" disabled={saving} style={{ padding:'14px 20px', border:'none', borderRadius:12, background:'#0f5ef7', color:'#fff', fontWeight:700 }}>{saving ? 'Saving...' : 'Save Settings'}</button></div>
      </form>
      <div style={{ marginTop:32 }}>
        <h3>Contact Inquiries</h3>
        <div style={{ display:'grid', gap:12 }}>
          {inquiries.map((item) => (
            <div key={item._id} style={{ background:'#fff', border:'1px solid #edf0f7', borderRadius:14, padding:16 }}>
              <div style={{ fontWeight:700 }}>{item.name} {item.phone ? `• ${item.phone}` : ''}</div>
              <div style={{ color:'#667085', margin:'4px 0 8px' }}>{item.email} {item.subject ? `• ${item.subject}` : ''}</div>
              <div>{item.message}</div>
            </div>
          ))}
          {!inquiries.length && <div style={{ padding:16, background:'#fff', border:'1px solid #edf0f7', borderRadius:14 }}>No contact inquiries yet.</div>}
        </div>
      </div>
    </div>
  );
}
